<template>
  <b-modal
    :id="`modal-new-aireport`"
    class="modal-new-aireport"
    :title="`${this.$t('aiReports.newAnalysis')} - ${modalType}`"
    size="l"
  >
    <div class="vue-step-wrapper">
      <vue-step
        style-type="style2"
        active-color="#4ce595"
        :now-step="step"
        v-model="step"
        :step-list="[
          $t('aiReports.newAiReport.analysisFilter'),
          $t('aiReports.newAiReport.analysisRevision'),
        ]"
      ></vue-step>
    </div>
    <div v-if="step === 1">
      <div class="new-swot-period">
        <span class="new-swot-period-label">
          {{ $t('aiReports.newAiReport.answersPeriod') }}
        </span>
        <div class="new-swot-period-options">
          <span v-if="selectedPeriod">
            {{ formatDate(selectedPeriod.start) }} à {{ formatDate(selectedPeriod.end) }}
          </span>
          <vc-date-picker
            locale="pt"
            mode="range"
            v-model="selectedPeriod"
            color="green"
          >
            <font-awesome-icon
              :icon="['fas', 'calendar-alt']"
              class="ml-2 calendar-icon"
              style="font-size: 18px; color: #4ce595;"
            />
          </vc-date-picker>
        </div>
      </div>
      <div class="new-swot-filter">
        <span class="new-swot-filter-label">
          {{ $t('aiReports.newAiReport.filters') }}
        </span>
        <div class="new-swot-filter-options">
          <b-form-select
            class="new-swot-filter-select"
            v-model="selectedFilter"
            :options="filterOptions"
          ></b-form-select>
        </div>
      </div>
      <div
        v-if="selectedFilter=='Grupo de Ação'"
        class="new-swot-filter"
      >
        <span class="new-swot-filter-label">
          {{ $t('aiReports.newAiReport.actionGroup') }}
        </span>
        <div class="new-swot-filter-options">
          <b-form-select
            class="new-swot-filter-select"
            v-model="selectedActionGroup"
            :options="actionGroupsOptions"
            @change="changedActionGroup"
          ></b-form-select>
        </div>
      </div>
      <div
        v-else-if="selectedFilter=='Ação'"
        class="new-swot-filter"
      >
        <span class="new-swot-filter-label">
          {{ $t('aiReports.newAiReport.action') }}
        </span>
        <div class="new-swot-filter-options">
          <b-form-select
            class="new-swot-filter-select"
            v-model="selectedAction"
            :options="actionsOptions"
            @change="changedAction"
          ></b-form-select>
        </div>
      </div>
      <div
        v-else-if="selectedFilter=='Perfil'"
        class="new-swot-filter"
      >
        <span class="new-swot-filter-label">
          {{ $t('aiReports.newAiReport.profile') }}
        </span>
        <div class="new-swot-filter-options">
          <b-form-select
            class="new-swot-filter-select"
            v-model="selectedProfile"
            :options="profilesOptions"
            @change="changedProfile"
          ></b-form-select>
        </div>
      </div>
      <div
        v-else-if="selectedFilter=='Filial'"
        class="new-swot-filter"
      >
        <span class="new-swot-filter-label">
          {{ $t('aiReports.newAiReport.ih1') }}
        </span>
        <div class="new-swot-filter-options">
          <b-form-select
            class="new-swot-filter-select"
            v-model="selectedIh1"
            :options="ih1Options"
            @change="changedIh1"
          ></b-form-select>
        </div>
      </div>
      <div
        class="new-swot-filter-result"
        v-if="
          selectedActionGroups.length > 0 ||
          selectedActions.length > 0 ||
          selectedProfiles.length > 0 ||
          selectedIh1s.length > 0"
      >
        <div class="new-swot-filter-result-label">
          <div class="left-line">
          </div>
          <div class="itens-label">
            {{ $t('aiReports.newAiReport.selectedItens') }}
          </div>
          <div class="right-line">
          </div>
        </div>
        <div
          class="new-swot-filter-result-action-group"
          v-if="selectedActionGroups.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.actionGroup') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedActionGroups"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item">
                {{ getActionGroupName(item) }}
                <div
                  class="tag-remove-item"
                  @click="removeActionGroup(item)"
                >
                  X
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="new-swot-filter-result-action"
          v-if="selectedActions.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.actions') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedActions"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item">
                {{ getActionName(item) }}
                <div
                  class="tag-remove-item"
                  @click="removeAction(item)"
                >
                  X
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="new-swot-filter-result-profile"
          v-if="selectedProfiles.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.profile') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedProfiles"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item profile-item">
                {{ item }}
                <div
                  class="tag-remove-item"
                  @click="removeProfile(item)"
                >
                  X
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="new-swot-filter-result-ih1"
          v-if="selectedIh1s.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.ih1') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedIh1s"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item">
                {{ getIh1Name(item) }}
                <div
                  class="tag-remove-item"
                  @click="removeIh1(item)"
                >
                  X
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="new-swot-revision">
        <span class="new-swot-revision-label">
          {{ $t('aiReports.newAiReport.revision') }}
        </span>
        <span class="new-swot-revision-text">
          Lembre-se de que ao clicar em Analisar, levará um tempo até o processamento
          ser concluído dependendo do número de dados cadastrados, após enviar aguarde
          alguns minutos até a conclusão da análise. <br> <br>
          Serão consultadas <strong>{{ this.totalAnswers }}</strong> Respostas sendo
          <strong>{{ this.commentedAnswers }}</strong> Respostas com comentário nos filtros:
        </span>
        <div class="revision-itens-label">
          {{ $t('aiReports.newAiReport.selectedFilters') }}
        </div>
        <div
          class="new-swot-filter-result-action-group"
          v-if="selectedActionGroups.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.actionGroup') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedActionGroups"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item">
                {{ getActionGroupName(item) }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="new-swot-filter-result-action"
          v-if="selectedActions.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.actions') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedActions"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item">
                {{ getActionName(item) }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="new-swot-filter-result-profile"
          v-if="selectedProfiles.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.profile') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedProfiles"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item profile-item">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="new-swot-filter-result-ih1"
          v-if="selectedIh1s.length > 0"
        >
          <div class="col-6 m-0 p-0 result-label">
            {{ $t('aiReports.newAiReport.ih1') }}:
          </div>
          <div class="container-tag-list">
            <div
              v-for="(item, indexTag) in selectedIh1s"
              :key="indexTag"
              class="container-tag"
            >
              <div class="tag-item">
                {{ getIh1Name(item) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div>
        <button
          class="btn btn-outline-primary modal-left-button"
          v-if="step === 2"
          @click="step = 1"
        >
          {{ $t('aiReports.newAiReport.goBackButton') }}
        </button>
        <button
          class="btn btn-outline-primary swot-cancel-button"
          @click="cancelModal"
        >
          {{ $t('aiReports.newAiReport.cancelButton') }}
        </button>
        <button
          :disabled="disableNextStep"
          v-if="step === 1"
          class="btn btn-primary"
          @click="nextStep"
        >
          {{ $t('aiReports.newAiReport.nextButton') }}
        </button>
        <button
          :disabled="commentedAnswers === 0"
          v-else
          class="btn btn-primary"
          @click="analyseAiReport"
        >
          {{ $t('aiReports.newAiReport.analyseButton') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';
import vueStep from 'vue-step';
import swal from 'sweetalert';
import moment from 'moment';

export default {
  components: { vueStep },

  computed: {
    //...mapState('actions', ['allActions', 'allGroups', 'actionGroupData']),
    ...mapState('branches', ['myIh1','ih1']),
    ...mapState('companies', ['myMetric']),
    ...mapState('actions', [
      'actionList',
      'allActions',
      'action',
      'totalActionList',
      'actionGroup',
      'allGroups',
      'actionGroupData',
    ]),
  },

  props: ['actionId', 'modalType'],
  data: () => ({
    userAuth: null,
    step: 1,
    selectedPeriod: null,
    selectedFilter: null,
    // used for single selection
    selectedActionGroup: null,
    selectedAction: null,
    selectedProfile: null,
    selectedIh1: null,
    // used for tags display
    selectedActionGroups: [],
    selectedActions: [],
    selectedProfiles: [],
    selectedIh1s: [],
    allGroupId: 'all',
    disableNextStep: false,
    // filters options
    periodOptions: [
      { value: 'Hoje', text: 'Hoje' },
      { value: 'Ontem', text: 'Ontem' },
      { value: 'Ultimos 30 dias', text: 'Últimos 30 dias' },
      { value: 'Mes atual', text: 'Mês atual' },
      { value: 'Mes anterior', text: 'Mês anterior' },
      { value: 'Ano atual', text: 'Ano atual' },
      { value: 'Ano anterior', text: 'Ano anterior' },
      { value: 'Todo periodo', text: 'Todo período' },
    ],
    filterOptions: [
      { value: null, text: 'Selecione um filtro' },
      { value: 'Grupo de Ação', text: 'Grupo de Ação' },
      { value: 'Ação', text: 'Ação' },
      { value: 'Perfil', text: 'Perfil' },
      { value: 'Filial', text: 'Filial' },
    ],
    actionGroupsOptions: [],
    actionsOptions: [],
    profilesOptions: [],
    ih1Options: [],
    totalAnswers: null,
    commentedAnswers: null,
  }),
  methods: {
    ...mapActions('actions', ['getAllActions']),

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    hideModal() {
      this.step = 1;
      this.$bvModal.hide('modal-new-aireport');
      // this.clearSelection();
    },
    cancelModal() {
      this.hideModal();
      this.clearSelection();
    },
    clearSelection() {
      this.selectedFilter = null;
      this.selectedActionGroup = null;
      this.selectedAction = null;
      this.selectedProfile = null;
      this.selectedIh1 = null;
      this.selectedActionGroups = [];
      this.selectedActions = [];
      this.selectedProfiles = [];
      this.selectedIh1s = [];
    },
    async nextStep(event) {
      // call API for getting summary
      this.disableNextStep = true;
      const response = await api.get(
        '/ia-analysis/answers',
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            companyId: this.userAuth.companyId,
            period: this.selectedPeriod,
            startDate: this.selectedPeriod.start,
            endDate: this.selectedPeriod.end,
            actionGroups: JSON.stringify(this.selectedActionGroups),
            actions: JSON.stringify(this.selectedActions),
            profiles: JSON.stringify(this.selectedProfiles),
            ih1s: JSON.stringify(this.selectedIh1s),
          },
        },
      );
      this.totalAnswers = response.data.totalAnswers;
      this.commentedAnswers = response.data.commentedAnswers;
      this.step = 2;
      this.disableNextStep = false;
    },
    async analyseAiReport(event) {
      this.hideModal();
      const iaReportType = this.modalType === 'Sumarização' ? 'summarizations' : 'swots';
      swal({
        title: 'Aguarde',
        text:
          `Sua ${this.modalType} está sendo processada!`,
        icon: 'success'
      })
      // call API for creating the new IA Report analysis document in collection
      const response = await api.post(
        `/${iaReportType}`,
        {
          companyId: this.userAuth.companyId,
          period: this.selectedPeriod,
          startDate: this.selectedPeriod.start,
          endDate: this.selectedPeriod.end,
          actionGroups: this.selectedActionGroups,
          actions: this.selectedActions,
          profiles: this.selectedProfiles,
          ih1s: this.selectedIh1s,
          totalAnswers: this.totalAnswers,
          commentedAnswers: this.commentedAnswers,
        },
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );
      this.clearSelection();
      EventBus.$emit('refreshlist', iaReportType);
    },
    async setActionGoupsList() {
      this.actionGroupsOptions = [];
      for (let i = 0; i < this.allGroups.length; i += 1) {
        this.actionGroupsOptions.push({
          value: this.allGroups[i]._id,
          text: this.allGroups[i].name,
        });
      }
    },
    async setActionsList() {
      this.actionsOptions = [];
      for (let i = 0; i < this.allActions.length; i += 1) {
        this.actionsOptions.push({
          value: this.allActions[i]._id,
          text: this.allActions[i].name,
        });
      }
    },
    async setProfilesList() {
      this.profilesOptions = [];
      this.profilesOptions.push({
        value: 'detrator',
        text: 'Detrator',
      });
      this.profilesOptions.push({
        value: 'neutro',
        text: 'Neutro',
      });
      this.profilesOptions.push({
        value: 'promotor',
        text: 'Promotor',
      });
    },
    async setIh1List() {
      this.ih1Options = [];
      for (let i = 0; i < this.ih1.listFilters.length; i += 1) {
        this.ih1Options.push({
          value: this.ih1.listFilters[i]._id,
          text: this.ih1.listFilters[i].corporate_name,
        });
      }
    },
    async changedActionGroup() {
      if (this.selectedActionGroup) {
        if (!(this.selectedActionGroups.indexOf(this.selectedActionGroup) >= 0)) {
          this.selectedActionGroups.push(this.selectedActionGroup);
        }
      }
      this.fixActionList();
      this.fixActionOptions();
    },
    async changedAction() {
      if (this.selectedAction) {
        if (!(this.selectedActions.indexOf(this.selectedAction) >= 0)) {
          this.selectedActions.push(this.selectedAction);
        }
      }
    },
    async changedProfile() {
      if (this.selectedProfile) {
        if (!(this.selectedProfiles.indexOf(this.selectedProfile) >= 0)) {
          this.selectedProfiles.push(this.selectedProfile);
        }
      }
    },
    async changedIh1() {
      if (this.selectedIh1) {
        if (!(this.selectedIh1s.indexOf(this.selectedIh1) >= 0)) {
          this.selectedIh1s.push(this.selectedIh1);
        }
      }
    },
    getActionGroupName(id) {
      for (let i = 0; i < this.allGroups.length; i += 1) {
        if (this.allGroups[i]._id === id) {
          return this.allGroups[i].name;
        }
      }
      return null;
    },
    getActionName(id) {
      for (let i = 0; i < this.allActions.length; i += 1) {
        if (this.allActions[i]._id === id) {
          return this.allActions[i].name;
        }
      }
      return null;
    },
    getIh1Name(id) {
      for (let i = 0; i < this.ih1.listFilters.length; i += 1) {
        if (this.ih1.listFilters[i]._id === id) {
          return this.ih1.listFilters[i].corporate_name;
        }
      }
      return null;
    },
    removeActionGroup(id) {
      let index = this.selectedActionGroups.indexOf(id);
      if (index > -1) {
        this.selectedActionGroups.splice(index, 1);
      }
      this.fixActionList();
      this.fixActionOptions();
    },
    removeAction(id) {
      let index = this.selectedActions.indexOf(id);
      if (index > -1) {
        this.selectedActions.splice(index, 1);
      }
    },
    removeProfile(id) {
      let index = this.selectedProfiles.indexOf(id);
      if (index > -1) {
        this.selectedProfiles.splice(index, 1);
      }
    },
    removeIh1(id) {
      let index = this.selectedIh1s.indexOf(id);
      if (index > -1) {
        this.selectedIh1s.splice(index, 1);
      }
    },
    fixActionList() {
      let newActionList = [];
      for (let i = 0; i < this.selectedActions.length; i += 1) {
        let remover = true;
        for (let j = 0; j < this.allActions.length; j += 1) {
          if (this.allActions[j]._id === this.selectedActions[i]) {
            for (let x = 0; x < this.selectedActionGroups.length; x += 1) {
              if (this.allActions[j].groupIdList.indexOf(this.selectedActionGroups[x]) >= 0) {
                remover = false;
              }
            }
            break;
          }
        }
        if (!remover) {
          newActionList.push(this.selectedActions[i]);
        }
      }
      this.selectedActions = newActionList;
    },
    fixActionOptions() {
      this.actionsOptions = [];
      if (this.selectedActionGroups.length > 0) {
        for (let i = 0; i < this.allActions.length; i += 1) {
          let remover = true;
          for (let x = 0; x < this.selectedActionGroups.length; x += 1) {
            if (this.allActions[i].groupIdList.indexOf(this.selectedActionGroups[x]) >= 0) {
              remover = false;
            }
          }
          if (!remover) {
            this.actionsOptions.push({
              value: this.allActions[i]._id,
              text: this.allActions[i].name,
            });
          }
        }
      } else {
        this.setActionsList();
      }
    },
  },
 
 async mounted() {

    this.selectedPeriod = {
      start: new Date(),
      end: new Date(),
    };
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    // gets all the company actions for building the filter
    await this.getAllActions({
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
      params: {
        groupId: this.allGroupId, 
      },
    });
    this.step = 1;
    await this.setActionGoupsList();
    await this.setActionsList();
    await this.setProfilesList();
    await this.setIh1List();
  },

  created() {
  },
};
</script>

<style lang="scss">
@import '@/themes/default/variables.scss';
#modal-new-ia-report .modal-content {
  display: flex;
  width: 645px !important;
  min-height: 700px !important;
  flex-direction: column;
  align-items: flex-start; 
}
#modal-new-ia-report .modal-header,
#modal-new-ia-report .modal-body,
#modal-new-ia-report .modal-footer {
  width: 100% !important;
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.vue-step-wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 0 24px;
  border-radius: 4px;
  margin: 8px 8px 16px;
}
.new-swot-filter,
.new-swot-period {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch; 
}
.new-swot-period,
.new-swot-revision {
  padding-top: 4px;
}
.new-swot-filter {
  padding-top: 20px;
}
.new-swot-filter-select,
.new-swot-period-select {
  display: flex;
  height: 30px;
  padding: 0px 12px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  border-radius: 4px;
  border: 1px solid #D9D9D9;
}
.new-swot-filter-options,
.new-swot-period-options {
  display: flex;
  width: 100%;
}
.new-swot-filter-label,
.new-swot-period-label {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: SF Pro Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 171.429% */ 
}
.new-swot-period-icon {
  padding: 6px;
  color: #4DE594;
  vertical-align: middle;
  font-size: 18px;
}
.new-swot-filter-result-label {
  padding-top: 20px;
  display: flex;
  align-items: center;
  gap: 2px;
  align-self: stretch; 
}
.itens-label {
  width: 340px;;
  color: #242424;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: SF Pro Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
}
.result-label {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: SF Pro Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */ 
}
.right-line,
.left-line {
  width: 100%;
  height: 1px;
  background: #D9D9D9;
}
.new-swot-filter-result-action-group,
.new-swot-filter-result-action,
.new-swot-filter-result-profile,
.new-swot-filter-result-ih1
{
  display: block;
  padding-bottom: 0px;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
  border-bottom: 1px solid #D9D9D9;
  padding-top: 12px;
  padding-bottom: 12px;
}
.container-tag-list {
  display: flex;
  overflow: scroll;
  white-space: nowrap;
  // flex-direction: row-reverse;
  width: 100%;
}
.container-tag {
  margin-bottom: 12px;
  padding: 0px 10px 0px 0px;
}
.tag-item {
  background: #37E688;
  color: #fff;
  width: 100%;
  padding: 2px 12px;
  border-radius: 4px;
  justify-content: space-between;
  display: flex;
}
.profile-item {
  background: #527BF2;
  text-transform: capitalize;
}
.tag-remove-item {
  padding-left: 6px;
  cursor: pointer;
}
.new-swot-revision {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch; 
}
.new-swot-revision-label {
  padding: 0px 10px;
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */   
}
.new-swot-revision-text {
  padding: 0px 10px;
  color: #333;
  text-align: justify;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  strong {
    font-weight: 700;
  }
}
.revision-itens-label {
  color: #242424;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Segoe UI;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  text-align: center;
  width: 100%;
  padding-top: 20px;
}
#modal-new-ia-report .btn {
  min-width: 90px;
}
.modal-left-button {
  position: absolute;
  left: 24px;
}
#modal-new-ia-report .swot-cancel-button {
  margin-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/ai-analysis/modal-new-aireport/index.vue